import { render, staticRenderFns } from "./WordCloudsWordsModal.vue?vue&type=template&id=ded0b2be&scoped=true"
import script from "./WordCloudsWordsModal.vue?vue&type=script&lang=js"
export * from "./WordCloudsWordsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded0b2be",
  null
  
)

export default component.exports